module.exports = __webpack_public_path__ + "static/media/IgIcon.f7cbafd8.svg";